<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { FieldChange } from "@/model/change";
import { useTeamStore } from "@/store/team";

defineProps<{ field: FieldChange<string> }>();

function teamName(id?: string) {
  return id ? useTeamStore().findTeam({ id })!.name : "";
}
</script>

<template>
  <div class="change horizontal">
    <template v-if="field.old">
      <span class="change-value">
        <SvgIcon name="persona/team" width="20" height="20" />
        {{ teamName(field.old) }}
      </span>
      <SvgIcon
        name="arrow/right"
        width="20"
        height="20"
        role="img"
        :aria-label="$t('label.cardDiff.changedTo')"
      />
    </template>
    <span class="change-value">
      <SvgIcon name="persona/team" width="20" height="20" />
      {{ teamName(field.new) }}
    </span>
  </div>
</template>
